export const HTTP_URL = process.env.REACT_APP_HTTP_URL
export const BASE_URL = ''
